// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1muxX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home.module.less
// module id = 583
// module chunks = 0